import React from 'react';
import { METRICS } from '../constants';
import { motion } from 'framer-motion';

const KillCount: React.FC = () => {
  return (
    <section id="results" className="py-24 bg-brand-red text-brand-black overflow-hidden relative">
      {/* Network graph background — subtle */}
      <div 
        className="absolute inset-0 opacity-[0.06] bg-cover bg-center pointer-events-none"
        style={{ backgroundImage: 'url(/images/network-graph.png)' }}
      />
      
      {/* Background strips */}
      <div className="absolute inset-0 flex">
        {Array(10).fill(0).map((_, i) => (
          <div key={i} className="flex-1 border-r border-black/10" />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 border-b-4 border-black pb-8">
          <div>
            <h2 className="text-6xl md:text-8xl font-sans uppercase tracking-tighter mb-2">
              Track Record
            </h2>
            <p className="font-mono text-sm opacity-70">
              Numbers that speak louder than promises.
            </p>
          </div>
          <span className="font-mono text-xs uppercase tracking-widest opacity-50 mt-4 md:mt-0">
            Verified • Q1 2026
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {METRICS.map((metric, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ delay: index * 0.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="flex flex-col items-center justify-center p-6 md:p-8 border-4 border-black bg-brand-white transform hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] transition-all duration-200"
            >
              <span className="font-mono text-xs font-bold mb-3 border-b-2 border-black pb-2 uppercase tracking-wider text-center">
                {metric.label}
              </span>
              <div className="flex items-baseline">
                <span className="text-3xl md:text-4xl font-sans font-black">
                  {metric.prefix}
                </span>
                <span className="text-5xl md:text-6xl font-sans font-black tracking-tighter">
                  {metric.value}
                </span>
                <span className="text-3xl md:text-4xl font-sans font-black">
                  {metric.suffix}
                </span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center font-mono text-xs uppercase tracking-widest opacity-60">
          *Figures based on client-reported revenue impact across all active engagements
        </div>
      </div>
    </section>
  );
};

export default KillCount;
